export default {
    buttons: {
        reset_password: 'Obnovi lozinku',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        email_not_exist: 'Email ne postoji',
    },
}
